import { useToast } from "@uhg-abyss/web/hooks/useToast";
import { IconSymbol, type IconSymbolProps } from "@uhg-abyss/web/ui/IconSymbol";
import type { ReactNode } from "react";

type CommonToastProps = {
  title: string;
  message: ReactNode;
  toastDisplayDuration?: number;
  toastType?: "error" | "info" | "success" | "warning";
  toastIcon?: IconSymbolProps["icon"];
  [key: string]: any; // Allow additional props
};

export const CommonToast = ({
  title,
  message,
  toastDisplayDuration = 5000,
  toastType = "error",
  toastIcon = "report",

  ...additionalProps
}: CommonToastProps) => {
  const { toast } = useToast();

  return toast.show({
    title,
    message,
    variant: toastType,
    autoClose: toastDisplayDuration,
    icon: <IconSymbol icon={toastIcon} />,
    ...additionalProps,
  });
};

export const ClearToastQueue = () => {
  const { toast } = useToast();
  return toast.clean();
};
